import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useContextValues } from "../context/RouteDataContext.jsx";
import { useEffect, useState } from "react";
import useGoTo from "../services/goTo.jsx";
import { trackEvent } from "../utils/analytics.js";
import StopsFilter from "./header-compoents/StopFilter.jsx";
import RouteSelectList from "./header-compoents/RouteSelectList.jsx";



export default function Header({ scope = "default" }) {
  const goTo = useGoTo();
  const {
    routeId,
    routeShortName,
    directionId,
    setDirectionId,
    timeUnit,
    setTimeUnit,
    routesList,
    directions,
    realtimeDirections,
    selectedDate,
    setSelectedDate,
    today,
  } = useContextValues();

  const isRealtime = scope === "realtime";
  const isSchedule = scope === "schedule";
  const displayDirections = isRealtime ? realtimeDirections : directions;

  const defaultCols = {
    xs: 12,
    sm: 6,
    md: 4,
    xl: 4,
  };

  const directionOptions =
    displayDirections && Object.keys(displayDirections).length
      ? Object.entries(displayDirections).map(([id, label]) => ({
        value: String(id),
        label,
      }))
      : [
        { value: "0", label: "Inbound" },
        { value: "1", label: "Outbound" },
      ];



  const handleDirectionChange = (e) => {
    setDirectionId(e.target.value);
    trackEvent("route_direction_changed", { route_id: routeId, direction_id: e.target.value });
  };

  const handleTimeUnitChange = (e) => {
    setTimeUnit(e.target.value);
    trackEvent("route_time_unit_changed", { route_id: routeId, time_unit: e.target.value });
  };

  const handleRouteChange = (e) => {
    goTo(`/plan-your-trip/routes/${e.target.value}`);
  };

  const handleDownloadClick = () => {
    trackEvent("route_schedule_download", { route_id: routeId });
  };

  const handleDateChange = (e) => {
    const nextDate = e.target.value || today;
    setSelectedDate(nextDate);
    trackEvent("route_date_changed", { route_id: routeId, selected_date: nextDate });
  };


  const hideRealtime = isRealtime ? "d-none" : "";
  const hideSchedule = isSchedule ? "d-none" : "";

  const downloadPath = routeShortName
    ? `/plan-your-trip/routes/${routeShortName}/download`
    : null;


  return (
    <header className={`row ictapp__header ictapp__header--${scope}`}>
      <Col>
        <Row>
          <Col>
            <Row className="justify-content-between">

              <Col {...(isRealtime ? { xs: 12 } : defaultCols)} className="mb-3">
                {/* ROUTE SELECT */}
                <Form.Group className="d-flex flex-column">
                  <Form.Label htmlFor={`route-select-${scope}`} className="h4">Route</Form.Label>
                  <RouteSelectList
                    inputId={`route-select-${scope}`}
                    label={null}
                    selectedRoute={routeShortName}
                    onChange={handleRouteChange}
                  />
                </Form.Group>
              </Col>

              <Col {...defaultCols} className={`mb-3 ${hideRealtime}`}>
                {/* DAY DROPDOWN */}
                <Form.Group className="d-flex flex-column">
                  <Form.Label htmlFor={`day-of-travel-${scope}`} className="h4">Day of Travel</Form.Label>
                  {/* Match TripForm's textbox role so iOS VoiceOver can open the native picker (WebKit bug 294649). */}
                  <Form.Control
                    type="date"
                    role="textbox"
                    id={`day-of-travel-${scope}`}
                    name="dayOfTravel"
                    value={selectedDate}
                    onChange={handleDateChange}
                    className="mt-auto"
                  />
                </Form.Group>
              </Col>

              <Col {...defaultCols} className={`mb-3 ${hideRealtime}`}>
                {/* STOPS FILTER */}
                <Form.Group className="d-flex flex-column">
                  <Form.Label htmlFor={`stops-filter-${scope}`} className="h4">Customize Table</Form.Label>
                  <StopsFilter inputId={`stops-filter-${scope}`} label={null} />
                </Form.Group>
              </Col>

              <Col xs={12} className="directions-group mb-3">
                {/* DIRECTION RADIO GROUP */}
                <Form.Group as="fieldset" className="ictapp__radio-group d-lg-flex align-items-lg-center gap-lg-3">
                  <legend className="h4 w-auto flex-shrink-0">Direction</legend>
                  <div className="d-flex flex-wrap align-items-center flex-grow-1">
                    {directionOptions.map((option) => (
                      <Form.Check
                        key={option.value}
                        id={`direction-${scope}-${option.value}`}
                        inline
                        type="radio"
                        name={`direction-${scope}`}
                        value={option.value}
                        checked={directionId === option.value}
                        onChange={handleDirectionChange}
                        label={option.label}
                      />
                    ))}
                    {/* DOWNLOAD SCHEDULE */}
                    <Button
                      {...(downloadPath
                        ? {
                          as: Link,
                          to: downloadPath,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        }
                        : {
                          as: "button",
                          type: "button",
                          disabled: true,
                        })}
                      variant="outline-primary"
                      // Show at large and above.
                      className={`header-download-schedule-button my-2 ms-auto text-decoration-none ${isRealtime ? "d-none" : "d-none d-lg-block"}`}
                      aria-label="Download PDF schedule"
                      onClick={downloadPath ? handleDownloadClick : undefined}
                    >
                      <i className="far fa-file-pdf"></i> Download Schedule
                    </Button>

                  </div>
                </Form.Group>
              </Col>

              <Col xs={12} className={`mb-3 ${hideSchedule}`}>
                {/* TIME UNIT */}
                <Form.Group as="fieldset" className="ictapp__radio-group d-lg-flex align-items-lg-center gap-lg-3">
                  <legend className="h4 w-auto flex-shrink-0">View Next Departure As</legend>
                  <div className="d-flex flex-wrap align-items-center flex-grow-1">

                    <Form.Check
                      id={`time-unit-${scope}-minutes`}
                      inline
                      type="radio"
                      name={`time-unit-${scope}`}
                      value="minutes"
                      checked={timeUnit === "minutes"}
                      onChange={handleTimeUnitChange}
                      label="Minutes to Wait"
                    />
                    <Form.Check
                      id={`time-unit-${scope}-time`}
                      inline
                      type="radio"
                      name={`time-unit-${scope}`}
                      value="time"
                      checked={timeUnit === "time"}
                      onChange={handleTimeUnitChange}
                      label="Departure Time"
                    />
                  </div>
                </Form.Group>
              </Col>


            </Row>
          </Col>
        </Row>
      </Col>
    </header >
  );
}
